<template>
  <div>
    <b-container fluid class="pb-5">
        
          <b-row>
            <b-col xl="12">
                <b-tabs content-class="mt-3" nav-wrapper-class="transaction-type" v-model="tabIndex">
                    <DepositHistory :data="types[0]" :key="types[0].id"></DepositHistory>
                </b-tabs>
            </b-col>
          </b-row>

    </b-container>
   
  </div>
</template>
<script>
  import Vue from 'vue'
  import DepositHistory from '@/components/TransactionHistory/DepositHistory';

  const transaction_list = [
          {"id":1,"name":"Deposit History"}
        ];

  export default {
    name: 'deposit-report',
    data() {
      return {
        tabIndex:-1,
        types : transaction_list
      }
    },
    components: {
      DepositHistory
    },
    methods:{
     
    }
  };
</script>
